import "./BathroomRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import RemodelingServices from "./sections/RemodelingServices";
import Transformations from "./sections/Transformations";
import Process from "./sections/Process";
import Remodelquestions from "./sections/Remodelquestions";
import Conversion, { GnciBooking } from "./sections/Conversion";
import Footer from "@/reusable_sections/Footer";

// Order (owner request Sept 17): booking form first, then completed-bathroom photos, then what a remodel can include.
// The former Hero section (./sections/Hero) is kept in the project but no longer shown.
export default function BathroomRemodelingPage() {
  return <div>
      <Header />
      <GnciBooking service="bathroom" />
      <Transformations />
      <RemodelingServices />
      <Process />
      <Remodelquestions />
      <Conversion />
      <Footer />
    </div>;
}